import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { QuoteDocument } from '@views/screens/Quote';
import type { AxiosResponse } from 'axios';

export interface GetQuoteDocumentsRequestParams {
  quoteKey: string;
}

const getQuoteDocumentsAPI = (params: GetQuoteDocumentsRequestParams) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/documents/all`,
    method: 'get',
    params,
  });
};

export type QuoteDocumentsResponse = QuoteDocument[];

export const fetchQuoteDocuments = async (params: GetQuoteDocumentsRequestParams): Promise<QuoteDocumentsResponse> => {
  const response: AxiosResponse<QuoteDocumentsResponse> = await getQuoteDocumentsAPI(params);
  return response.data;
};
